export const setCookie = (name: string, value: string | number | boolean): boolean => {
  if (
    !name ||
    /^(?:expires|max-age|path|domain|secure)$/i.test(name) ||
    typeof document === 'undefined'
  ) {
    return false;
  }

  const threeDays = new Date(new Date().getTime() + 72 * 60 * 60 * 1000);
  const expires = `; expires=${threeDays.toUTCString()}`;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/`;
  return true;
};
